export default {
    'a-promotion_tiergroup': () => import(/* webpackChunkName: "tier_group_professional" */ './professional'),
} as { [key: string]: () => Promise<unknown> }